export default angular
    .module('bl.skipstep', [])
    .name;


// WEBPACK FOOTER //
// src/public/javascripts/skip-step-function/skip_step.module.js